module.exports = __webpack_public_path__ + "img/shuxian10.24d0aadd.png";